exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody > table > tbody > tr > td.dataTables_empty {\n  text-align: center !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/staff-contact/staff-contact.component.scss
// module id = ../../../../../src/app/crm/staff-contact/staff-contact.component.scss
// module chunks = main